import React, { useEffect, Suspense, lazy } from "react";
import CarouselHomepage from "web/pages/public/landing-page/StartPage/CarouselHomepage";
import BigOrSmall from "web/pages/public/landing-page/StartPage/BigOrSmall";
import LandingPage from "./LandingPage";
import PalletPlusModal from "web/pages/public/landing-page/StartPage/EverStop/PalletPlusModal";
import { Container } from "web/pages/public/landing-page/StartPage/StartPageStyled";
import GetQuoteComponent from "./GetQuote";
const EverStop = lazy(() => import("./EverStop"));
const OneStop = lazy(() => import("./OneStop"));
const VideoSection = lazy(() => import("./VideoSection"));
const LandingFooter = lazy(() => import("../LandingFooter/"));

const StartPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container>
      <LandingPage />
      {/* <GetQuoteComponent /> */}

      {/* <PalletPlusModal /> */}

      {/* <CarouselHomepage /> */}

      {/* <BigOrSmall /> */}

      {/* <Suspense fallback={<div></div>}>
        <EverStop />
      </Suspense>

      <Suspense fallback={<div></div>}>
        <OneStop />
      </Suspense>

      <Suspense fallback={<div></div>}>
        <VideoSection />
      </Suspense> */}

      <Suspense fallback={<div></div>}>
        <LandingFooter />
      </Suspense>
    </Container>
  );
};

export default StartPage;
